import { call } from 'redux-saga/effects';

import storage from 'utils/storage';

export function* persistItemsPerPage(storageKey, { payload = 20 } = {}) {
  yield call(storage.setItem, storageKey, payload);
}
